<template>
  <div class="panel-row" v-loading="loading">
    <div class="left_label">
      属性维度
      <!--      <el-tooltip class="item" effect="dark" content="分析结果将会按照所选维度做分组展示" placement="top-start">-->
      <!--        <i class="el-icon-question" />-->
      <!--      </el-tooltip>-->
    </div>
    <div class="weidu-cont">
      <div class="weidu-item" v-for="(item, idx) in list" :key="`${item.val}_${idx}`">
        <select-props
          size="medium"
          v-model="item.val"
          :show-total="true"
          :condition-property-options="selectOptions"
          :showVirtual="true"
          @change="handleChange($event, idx)"
          class="weidu-select-props"
        ></select-props>
        <div class="close" @click="handleRemove" v-if="list.length > 0">
          <icon name="close"></icon>
        </div>
      </div>
      <t-button @click="handleAdd" size="medium" style="font-size: 12px; width: 80px" variant="outline">
        <icon name="add" slot="icon" />
        属性
      </t-button>
    </div>
  </div>
</template>

<script>
import SelectProps from '@/components/analysis/property-selector.vue';
import { getAllProperty } from '@/api/analysis/custom-analysis';

const TOTAL = () => ({ val: '', label: '总体' });

export default {
  name: 'attribution-select',
  components: {
    SelectProps,
  },
  data() {
    return {
      loading: false,

      conditionPropertyOptions: [
        // { propertyType: '', propertyName: 'channel', propertyDesc: '渠道', propertyDataType: 'string' },
      ],
      list: [TOTAL()],
      selectOptions: [],
    };
  },
  props: {
    value: {
      type: String,
    },
    options: {
      type: Array,
      default: () => [],
    },
    // loadingDetail: {
    //   type: Boolean,
    //   default: false,
    // },
  },

  created() {
    this.getFormOption();
    this.initFormValue();
  },

  watch: {
    // loadingDetail() {
    //   if (!this.loadingDetail) {
    //     this.initFormValue(this.data);
    //   }
    // },
    options(cur) {
      this.selectOptions = cur;
    },
    value() {
      this.initFormValue();
    },
  },

  methods: {
    getFormOption() {
      // 如果有外部的 option 不需要自己请求
      if (this.options) return;
      this.loading = true;
      getAllProperty({ params: { hasData: 1, isVisible: 1 } })
        .then(res => {
          const { list = [] } = res || {};
          this.selectOptions = list.map(item => ({
            propertyName: item.name,
            propertyDesc: item.chineseName,
            propertyDataType: item.javaType,
            propertyType: item.propertyType,
          }));

          if (this.list && this.list.length) {
            const names = this.list.map(l => l.val);
            let selected = list.filter(l => names.includes(l.name));
            if (!selected.length) {
              selected = [TOTAL()];
            }
            this.list = selected;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    initFormValue() {
      if (this.value === null || this.value === undefined) return;
      if (typeof this.value !== 'string') return;

      const datas = this.value.split(',');

      this.list = datas.map(d => ({ val: d }));
    },

    getSelectLabel(selected = []) {
      const names = selected.map(l => l.val);
      const values = this.selectOptions
        .filter(p => names.includes(p.propertyName))
        .map(s => ({ val: s.propertyName, label: s.propertyDesc }));
      return values;
    },

    // eslint-disable-next-line no-unused-vars
    handleChange(item, index) {
      const changeData = this.list.map(l => (l.val === 'all' ? '' : l.val)).join(',');
      this.$emit('input', changeData);

      // const option = this.selectOptions.find(s => s.propertyName === item);
      // let data = { val: '', label: '全部' };
      // if (option) data = { val: option.propertyName, label: option.propertyDesc };
      // this.$set(this.list, index, data);
      this.$emit('onChange', this.list);
    },
    handleRemove(idx) {
      this.list.splice(idx, 1);
      this.handleChange();
    },
    handleAdd() {
      if (this.list.length >= 5) {
        this.$message.warning('最多配置5个属性');
        return;
      }
      const initValue = TOTAL();
      this.list.push(initValue);
      this.handleChange(initValue, initValue, this.list.length);
    },
  },
};
</script>

<style scoped lang="less">
.panel-row {
  display: flex;
  margin-top: 20px;

  .left_label {
    width: 100px;
    min-width: 100px;
    color: #888888;
    height: 28px;
    line-height: 28px;
    font-size: 12px;
  }

  .weidu-cont {
    display: flex;
    align-items: center;
    flex: 1;
    &:hover {
      background-color: #fafafa;
    }

    .weidu-item {
      padding: 0 10px 0 10px;
      position: relative;

      .weidu-select-props {
        ::v-deep button {
          font-size: 12px;
        }
      }

      &:first-child {
        padding-left: 0;
      }

      &:hover {
        background-color: rgb(234, 234, 234);

        .close {
          display: block;
        }
      }

      .close {
        position: absolute;
        display: none;
        right: -2px;
        top: -10px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        border-radius: 50%;
        color: white;
        background-color: #888888;
        cursor: pointer;
      }
    }
  }
}
</style>
